import { render, staticRenderFns } from "./InsuranceData.vue?vue&type=template&id=fa5fd5fe"
import script from "./InsuranceData.vue?vue&type=script&lang=js"
export * from "./InsuranceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports